<template lang="pug">
  .products__list(ref="list")
    .products__list-arrow.products__list-arrow_left(v-lazyload ref="arrow_left")
    .products__list-arrow.products__list-arrow_right(v-lazyload ref="arrow_right")
    .products__list-slider
      .products__list-content
        .products__list-item-wrapper.animated(
          ref="wrapper"
          v-for="product in items"
          :key="product.code"
          v-tap="() => SET_ITEM(product)"
          :class="`products__list-item-wrapper_${product.code}`"
        )
          .products__list-item(
            v-lazyload
            :class="{'products__list-item_active': product.code === item.code}"
          )
          .products__list-name {{ product.name }}
</template>

<script>
import inViewport from '@/helpers/inViewport'
import anime from 'animejs'
import { mapState, mapMutations } from 'vuex'
import Swiper, { Navigation } from 'swiper'

Swiper.use([Navigation])

export default {
  name: 'ProductsList',
  data: () => ({
    swiper: null
  }),
  computed: {
    ...mapState('products', ['items', 'item'])
  },
  created () {
    this.$nextTick(() => {
      this.swiper = new Swiper('.products__list-slider', {
        speed: 800,
        wrapperClass: 'products__list-content',
        slideClass: 'products__list-item-wrapper',
        breakpoints: {
          1024: {
            slidesPerView: 4
          },
          1260: {
            slidesPerView: 5
          }
        },
        watchOverflow: true,
        navigation: {
          nextEl: '.products__list-arrow_right',
          prevEl: '.products__list-arrow_left',
          disabledClass: 'products__list-arrow_disabled'
        }
      })
    })
  },
  watch: {
    items () {
      this.initAnimation()
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.initAnimation()
    })

    inViewport(this.$el, this.initAnimation, 'half')
  },
  updated () {
    this.swiper.update()
  },
  methods: {
    ...mapMutations('products', ['SET_ITEM']),
    initAnimation () {
      this.$nextTick(() => {
        inViewport(this.$refs.list, () => {
          anime.timeline()
            .add({
              targets: this.$refs.wrapper,
              opacity: [0, 1],
              scale: [2, 1],
              translateY: ['50%', 0],
              duration: 400,
              delay: anime.stagger(200),
              easing: 'easeOutQuad'
            })
            .add({
              targets: this.$refs.choose,
              opacity: [0, 1],
              translateX: ['-50%', 0],
              duration: 200,
              easing: 'easeOutQuad'
            })
        }, 'bottom')
      })
    }

  }
}
</script>
